import inspirationsService from './inspirationsService'

export default inspirationsService



// WEBPACK FOOTER //
// ../src/services/inspirationsService/index.js